import FormValidator from "./FormValidator";
import { request } from "../utils/axios";
import {
  getSessionId,
  getSessionData,
  getShadowRoot,
  setSessionData,
} from "../utils/store";
import { setLoading, isMobile, setError } from "../utils";
import flatpickr from "flatpickr";
import flatpickrCss from "flatpickr/dist/themes/dark.css";
import { nextPrev } from "../utils/StepService";

class BasicAgeVerification {
  datePicker = null;

  render = async () => {
    const sessionData = getSessionData();
    sessionData.isbasicVerification = true;

    const modalBox = getShadowRoot().querySelector("#identity-modal__box");

    if (modalBox.querySelector("#basicAgeVerification")) return;

    const flatpickrStyleSheet = document.createElement("style");
    flatpickrStyleSheet.textContent = flatpickrCss;
    getShadowRoot().appendChild(flatpickrStyleSheet);

    modalBox.insertAdjacentHTML(
      "beforeend",
      `
<style>    
  .identity__row {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>

<form class="form-content" id="basicAgeVerification" data-form-tab>
  <div class="identity__col-12">
    <div class="identity-alert__error" id="identity-alert__error" style="display:none;">
      <button data-close="close" style="display:none;" type="button">&times;</button>
      <svg class="icon" width="20px" height="20px" aria-hidden="true" role="img">
        <use href="#svg__alert-error" xlink:href="#svg__alert-error"></use>
      </svg>
      <div id="identity-alert__message" data-text="text"></div>
    </div>
  </div>

  <div class="identity__col-12">
    <div class="identity-field identity-field-addon floating-field identity-field-dob">
      <input name="dob" id="dob" type="text" placeholder="Date of Birth*" class="identity-input" maxlength="10" />
      <label for="dob" class="identity-floating-label">Date of Birth (MM/DD/YYYY)*</label>
      <svg class="svg identity-addon-icon addon-icon" id="calendarIcon" width="40px" height="40px" aria-hidden="true" role="img">
        <use href="#svg__calendar" xlink:href="#svg__calendar"></use>
      </svg>
      <svg class="icon icon-error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
      </svg>
      <span class="error-message"></span>
    </div>
  </div>

  <div class="identity__col-12">
    <div class="identity-field floating-field">
      <input name="zip" id="zip" type="text" placeholder="none" class="identity-input" onkeypress="return /[0-9]/i.test(event.key)" maxlength="5" />
      <label for="zip" class="identity-floating-label">Zip</label>
      <svg class="icon icon-error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
      </svg>
      <span class="error-message"></span>
    </div>
  </div>

  <div class="consent-box" style="margin-top:20px">
    <div class="identity__col-12">
      <div class="identity__row column-reverse-xs">
        <div class="identity__col-6">
          <div class="identity-field">
            <button id="btn-continue" type="submit" class="identity-btn btn-continue">
              Continue
              <span class="loading-icon">
                <svg class="svg" width="20px" height="20px" aria-hidden="true" role="img">
                  <use href="#svg__loader" xlink:href="#svg__loader"></use>
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>`
    );

    this.bindEvents();
  };

  async bindEvents() {
    const basicAgeVerificationForm = getShadowRoot().querySelector("#basicAgeVerification");

    basicAgeVerificationForm.addEventListener("submit", (event) => {
      event.preventDefault();

      const fields = {
        dob: { required: true },
        zip: { required: false },
      };

      this.validator = new FormValidator(event.target, fields);
      const validData = this.validator.validate();

      if (validData.isValid) {
        const [month, day, year] = validData.data.dob.split(/[\/\-]/);
        const date = new Date(`${year}-${month}-${day}`);
        validData.data.dob = date.toISOString().split("T")[0];

        setLoading(true);

        request
          .post(`/SaveBasicAgeVerification/`, {
            dob: validData.data.dob,
            zip: validData.data.zip,
            sessionId: getSessionId(),
          })
          .then(({ data }) => {
            setSessionData(data.data);
            setLoading(false);
            nextPrev(1);
          })
          .catch(({ response }) => {
            setError(response);
            setLoading(false);
          });
      }
    });

    const myInput = basicAgeVerificationForm.querySelector("#dob");

    myInput.addEventListener("input", function () {
      let inputValue = this.value.replace(/\D/g, "");
      let formattedValue = "";

      if (inputValue.length > 0) {
        formattedValue += inputValue.substring(0, 2);
        if (inputValue.length >= 3) {
          formattedValue += "/" + inputValue.substring(2, 4);
        }
        if (inputValue.length >= 5) {
          formattedValue += "/" + inputValue.substring(4, 8);
        }
      }

      this.value = formattedValue;
    });

    const options = {
      allowInput: true,
      enableTime: false,
      dateFormat: "m/d/Y",
      disableMobile: true,
      disable: [date => new Date() < date],
      appendTo: getShadowRoot(),
      onClose: () => {},
    };

    this.datePicker = flatpickr(myInput, options);

    const calendarContainer = this.datePicker.calendarContainer;

    if (isMobile()) {
      calendarContainer.addEventListener("touchstart", event => event.stopPropagation());
    } else {
      calendarContainer.addEventListener("mousedown", event => event.stopPropagation());
    }

    const calendarIcon = basicAgeVerificationForm.querySelector("#calendarIcon");
    calendarIcon.addEventListener("click", () => {
      myInput.focus();
    });

    myInput.addEventListener("blur", function (event) {
      if (event?.relatedTarget?.className?.indexOf("identity") !== -1) {
        let flatpickrInstance = myInput._flatpickr;
        flatpickrInstance.close();
      }
    });
  }
}

export default BasicAgeVerification;